import React from 'react';
import Grid from '@mui/material/Grid2';
import { IEducationalVideoItem } from '../../../dataObjects/models/educationalVideos';
import { EducationalVideosRelatedCatalogGridViewItem } from './EducationalVideosRelatedCatalogGridViewItem';


export interface IEducationalVideosRelatedCatalogGridViewProps {
  relatedCatalogs: Array<IEducationalVideoItem>;
}


export const EducationalVideosRelatedCatalogGridView: React.FC<IEducationalVideosRelatedCatalogGridViewProps> = (props: IEducationalVideosRelatedCatalogGridViewProps) => {
  EducationalVideosRelatedCatalogGridView.displayName = 'Product Videos RelatedCatalog Grid View';

  const { relatedCatalogs } = props;

  return (
    <>
      {/* <Grid container spacing={2} > */}
      <Grid container spacing={2} >
        {
          relatedCatalogs.map(relatedCatalog =>
            <Grid key={relatedCatalog.id} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
              <EducationalVideosRelatedCatalogGridViewItem relatedCatalog={relatedCatalog} />
            </Grid>
          )
        }
      </Grid>
    </>
  );

}